import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoutes from "../../core/routes/PrivateRoutes";
import { MeuPerfil } from "../pages/MeuPerfil";
import { ListarUsuarios } from "../pages/ListarUsuarios";
import { CadastrarUsuario } from "../pages/CadastrarUsuario";
import { Layout } from "../../core/components/Layout";

interface IUsuarioRoutesProps {
    autenticado: boolean;
}

export const UsuarioRoutes = ({ autenticado }: IUsuarioRoutesProps) => {
    return (
        <Routes>
            <Route element={
                <Layout titulo="Usuários">
                    <PrivateRoutes
                        autenticado={autenticado}
                    />
                </Layout>
            }>
                <Route path="/" element={<ListarUsuarios />} />
                <Route path="/cadastrar" element={<CadastrarUsuario />} />
                <Route path="/meu-perfil" element={<MeuPerfil />} />
                <Route path="*" element={<Navigate to="/pagina-nao-encontrada" />} />
            </Route>
        </Routes>
    );
}